<template>
  <a-card :style="`min-height:${chartMinHeight};`">
    <base-chart
      ref="analysisChart"
      id="analysis-chart"
      :loading="loading"
      chartType="ve-histogram"
      :chartData="chartData"
      :chartConfig="chartConfig"
      :chartSettings="chartSettings"
      :chartExtend="chartExtend"
      :extraToolbox="extraToolbox" />
    <!-- <download-excel v-show="false" ref="excel" :data="analysisExcelData" :fields="analysisExcelColumnMap" :name="`${extraToolbox.pdf.name}.xls`" /> -->
  </a-card>
</template>

<script>
import * as R from 'ramda'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { numerify } from '@/filters'
import AnalysisesMixin from '../mixins/analysises'

export default {
  name: 'AnalysisesChart',
  components: {
  },
  mixins: [currencyRequest, AnalysisesMixin],
  props: {
    dataList: {
      type: Array,
      require: true,
    },
    formData: {
      type: Object,
      require: true,
    },
    loading: {
      type: Boolean,
    },
    tagGroupParams: Object,
    projectTagGroupParams: Object,
    instanceTagGroupParams: Object,
    chartConfigs: {
      type: Object,
      default: () => { return {} },
    },
  },
  data () {
    return {
      chartData: {
        columns: [],
        rows: [],
      },
    }
  },
  computed: {
    chartMinHeight () {
      return this.chartConfigs.height || '400px'
    },
    dataGroupCount () {
      let groupCount = 1
      if (this.dataList[0] && this.dataList[0].data && this.dataList[0].data[0] && this.dataList[0].data[0].hasOwnProperty('name')) {
        groupCount = 2
      }
      return groupCount
    },
    chartConfig () {
      return {
        height: '400px',
        width: '100%',
        legend: {
          type: 'scroll',
          left: 100,
          right: 200,
          formatter: (name) => {
            if (this.formData.group[0] === 'tag' && name === '___no_value__') {
              return this.$t('common_736')
            }
            return this.getNameI18n(name, this.formData.group[0])
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            shadowStyle: {
              color: 'rgb(77, 161, 255)',
              opacity: 0.1,
            },
          },
          position: (point, params, dom, rect, size) => {
            dom.style.border = 'none'
            dom.style.backgroundColor = 'transparent'
            let series = params
            let total = R.sum(series.map(item => item.value))
            series.sort((a, b) => b.value - a.value)
            series = series.map((line) => {
              const name = this.getNameI18n(line.seriesName, this.formData.group[0])
              const percent = numerify(line.value / total, '0.00%')
              return `
                <div class='billanalysis' style="color: #616161;">
                  ${line.marker} 
                  <span>${name}</span>:  
                  <span>
                    ${this.currencySign} ${numerify(line.value, '0,0.00')}
                    <i class="percent">${line.value === 0 ? '0.00%' : percent}</i>
                  </span>
                </div>`
            }).join('')
            if (series.length === 0) {
              dom.innerHTML = ''
              return
            }
            total = this.$t('common_733', [`${this.currencySign} ${numerify(total, '0,0.00')}`])
            const wrapper = `<div class="chart-tooltip-wrapper">
                          <div style="color: #5D6F80;">${params[0].name}</div>
                          <div class="lines-wrapper">${series}</div>
                          <div style="color: #5D6F80;margin-top:10px">${total}</div>
                        </div>`
            dom.innerHTML = wrapper
            // return point
          },
        },
        toolbox: {
          show: true,
          feature: {
            magicType: {
              show: true,
              type: ['line', 'bar', 'stack'],
              option: {
                line: {
                  stack: '',
                },
                bar: {
                  stack: 1,
                },
              },
              title: { line: this.$t('monitor.chart.toolbar.line'), bar: this.$t('monitor.chart.toolbar.bar') },
            },
          },
        },
        ...this.chartConfigs,
      }
    },
    chartExtend () {
      const that = this
      return {
        series: {
          barMaxWidth: 30,
          type: 'bar',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: { color: 'rgb(77, 161, 255)', opacity: 0.1 },
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              return `${that.currencySign} ${value}`
            },
          },
        },
        // dataZoom: {
        //   type: 'inside', /* 数据缩放 **/
        // },
      }
    },
    chartSettings () {
      return {
        stack: {
          alerts: this.chartData.columns.slice(1),
        },
        barMaxWidth: 30,
      }
    },
    extraToolbox () {
      return {
        pdf: {
          name: this.$t('bill.text_118'),
          target: '#analysis-chart',
        },
        excel: {
          export: this.exportExcel,
        },
      }
    },
  },
  watch: {
    dataList: {
      deep: true,
      handler () {
        this.initChartData()
      },
      immediate: true,
    },
  },
  methods: {
    exportExcel () {
      // if (this.dataGroupCount > 1) {
      //   this.$emit('exportExcel')
      // } else {
      //   this.$refs.excel.generate()
      // }
      this.$emit('exportExcel')
    },
    initChartData () {
      // 获得按一个聚合维度请求格式的数据
      let dataList = []
      if (this.dataGroupCount > 1) {
        dataList = this.dataList.map(item => {
          const data = this.groupStatValue(item.data)
          const stat_values = data.map(obj => obj.stat_value)
          const stat_value_sum = R.sum(stat_values)
          return {
            data,
            name: item.name,
            stat_value_sum,
          }
        })
        dataList = this.getTop10AndOtherData(dataList)
      } else {
        dataList = this.getTop10AndOtherData(this.dataList)
      }
      // 按一维聚合生成数据
      const columns = []
      let rows = []
      if (dataList[0] && dataList[0].data && dataList[0].data[0]) {
        dataList.map(item => {
          columns.push(item.name)
        })
        // eslint-disable-next-line
        const initRows = new Array(dataList[0].data.length)
        dataList.map((item, index) => {
          item.data.map((item2, index2) => {
            if (index === 0) {
              if (!initRows[index2]) initRows[index2] = {}
              initRows[index2][this.$t('bill.date')] = item2.date_info
            }
            initRows[index2] && (initRows[index2][item.name] = item2.stat_value)
          })
        })
        rows = initRows
      }
      this.chartData.columns = [this.$t('bill.date'), ...columns]
      this.chartData.rows = rows
    },
    getTop10AndOtherData (dataList) {
      const _dataList = R.clone(dataList)
      const top10DataList = _dataList.slice(0, 10)
      const otherDataList = _dataList.slice(10)
      const len = otherDataList[0]?.data?.length || 0
      const otherData = { name: this.$t('bill.other'), data: [] }

      for (let i = 0; i < len; i++) {
        let sum = 0
        for (let j = 0; j < otherDataList.length; j++) {
          sum += otherDataList[j].data[i]?.stat_value || 0
        }
        otherData.data.push({ stat_value: sum })
      }
      if (otherData.data?.length > 0) {
        top10DataList.push(otherData)
      }
      return top10DataList
    },
  },
}
</script>
<style lang="scss">
.billanalysis {
  .percent {
    display: inline-block;
    border: 1px solid #4DA1FF;
    color: #4DA1FF;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    font-size: 12px;
    font-style: normal;
  }
}
</style>
